import request from '../request'

export default {
    getRoles() {
        return request.get('rol')
    },

    addRolPermiso(rolPermiso) {
        return request.post('rol_permiso', rolPermiso)
    },

    deleteRolPermiso(rolPermisoId) {
        return request.delete(`rol_permiso/${rolPermisoId}`)
    },

    addRol(rol) {
        return request.post('rol', rol)
    },

    updateRol(rol) {
        return request.put('rol', rol)
    },

    updateEstadoRol(rolData) {
        return request.put(`rol/${rolData.rolId}/estado`, { borrado: rolData.borrado })
    },

    duplicateRol(rolId) {
        return request.post(`rol/${rolId}/duplicar`)
    }
}
